/* global $:false */

export default class MegaMenu {
  static init () {
    Array.from($('.js-megamenu')).map((el) =>
      new MegaMenu(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
    this.setInitialSize()
    this.animateWhenScrolling()
  }

  findElements () {
    this.logo_container = this.el.find('.js-topmenu-logo-container')
    this.logo = this.el.find('.js-topmenu-logo')
    this.network_tagline = this.el.find('.js-topmenu-network')

    this.auctionsLink = this.el.find('.js-menu-heading-auctions')
    this.contactLink = this.el.find('.js-menu-heading-contact')
    this.auctionsContainer = this.el.find('.js-menu-auctions')
    this.contactContainer = this.el.find('.js-menu-contact')
  }

  setupBindings () {
    this.contactLink.click(e => {
      e.preventDefault()
      const openMe = !this.contactContainer.is(':visible')
      this.closeAll()
      if (openMe) {
        $(e.target).addClass('selected')
        this.contactContainer.show()
      }
    })

    this.auctionsLink.click(e => {
      e.preventDefault()
      const openMe = !this.auctionsContainer.is(':visible')
      this.closeAll()
      if (openMe) {
        $(e.target).addClass('selected')
        this.auctionsContainer.show()
      }
    })
  }

  closeAll () {
    this.auctionsLink.removeClass('selected')
    this.contactLink.removeClass('selected')
    this.auctionsContainer.hide()
    this.contactContainer.hide()
  }

  setInitialSize () {
    $(() => {
      this.logo.data('size', 'big')
    })
  }

  animateWhenScrolling () {
    $(window).scroll(() => {
      if ($(document).scrollTop() > 50) {
        if (this.logo.data('size') === 'big') {
          this.logo.data('size', 'small')
          this.logo.addClass('c-topmenu__logo--minimal')
          this.logo_container.addClass('c-topmenu__logo_container--minimal')
          this.network_tagline.addClass('c-topmenu__network--minimal')
        }
      } else {
        this.logo.data('size', 'big')
        this.logo.removeClass('c-topmenu__logo--minimal')
        this.logo_container.removeClass('c-topmenu__logo_container--minimal')
        this.network_tagline.removeClass('c-topmenu__network--minimal')
  }
    })
  }
}
